var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Stacker } from '@honeycomb/ui-core';
import { HotelDepositPill } from '../HotelDepositPill/HotelDepositPill';
import { HotelMobileDiscountPill } from '../HotelMobileDiscountPill/HotelMobileDiscountPill';
import { HotelPayMonthlyPill } from '../HotelPayMonthlyPill/HotePayMonthlyPill';
import { useHotelPricingPills } from '../utils/useHotelPricingPills';
/**
 * Render the relevant hotel pricing pills in a Stacker component.
 */
export function HotelPricingPills(_a) {
    var { pricingSummary, roomIndex, boardIndex, suppressTypes, chipProps } = _a, other = __rest(_a, ["pricingSummary", "roomIndex", "boardIndex", "suppressTypes", "chipProps"]);
    const pills = [];
    const getDataId = (suffix) => {
        let id = suffix;
        if (boardIndex !== undefined) {
            id = `board_${boardIndex}_${id}`;
        }
        if (roomIndex !== undefined) {
            id = `room_${roomIndex}_${id}`;
        }
        return id;
    };
    const validTypes = useHotelPricingPills(pricingSummary);
    // Mobile discount
    if (validTypes.mobileDiscount && !(suppressTypes === null || suppressTypes === void 0 ? void 0 : suppressTypes.mobileDiscount)) {
        pills.push(React.createElement(HotelMobileDiscountPill, { chipProps: Object.assign({ size: 's' }, chipProps), "data-id": getDataId('mobile_discount_pill'), key: "mobile-discount" }));
    }
    // Deposit
    if (validTypes.deposit && !(suppressTypes === null || suppressTypes === void 0 ? void 0 : suppressTypes.deposit) && pricingSummary.depositFormatted) {
        pills.push(React.createElement(HotelDepositPill, { chipProps: Object.assign({ size: 's' }, chipProps), depositFormatted: pricingSummary.depositFormatted || '', "data-id": getDataId('deposit_pill'), key: "deposit" }));
    }
    // Pay monthly
    if (validTypes.payMonthly && !(suppressTypes === null || suppressTypes === void 0 ? void 0 : suppressTypes.payMonthly) && pricingSummary.monthlyInstalment) {
        pills.push(React.createElement(HotelPayMonthlyPill, { chipProps: Object.assign({ size: 's' }, chipProps), monthlyInstalment: pricingSummary.monthlyInstalment, "data-id": getDataId('pay_monhly_pill'), key: "pay-monthly" }));
    }
    if (pills.length > 0) {
        return React.createElement(Stacker, Object.assign({}, other), pills.map((pill) => pill));
    }
    return null;
}
